export class OnPressKeyRules {
  private static handleTagNames = (ch, e) => {
    if (ch === 32) return e.preventDefault();
    if (ch >= 48 && ch <= 57) return e.preventDefault();
    if (ch >= 65 && ch <= 90) return true;
    if (ch >= 97 && ch <= 122) return true;
    return e.preventDefault();
  };

  private static handleInteger = (ch, e) => {
    if (ch > 31 && (ch < 48 || ch > 57)) {
      return e.preventDefault();
    }
    return true;
  };

  private static handlePressKey(e, formatType: "Integer" | "TagName") {
    e = e || window.event;
    const ch = e.which ? e.which : e.keyCode;
    switch (formatType) {
      case "Integer":
        OnPressKeyRules.handleInteger(ch, e);
        break;
      case "TagName":
        OnPressKeyRules.handleTagNames(ch, e);
        break;
      default:
        return true;
    }
  }

  public static handlePressIntegerKey = (e) => {
    return OnPressKeyRules.handlePressKey(e, "Integer");
  };

  public static handlePressTagNameKey = (e) => {
    return OnPressKeyRules.handlePressKey(e, "TagName");
  };
}
